import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronUp, faChevronDown } from "@fortawesome/free-solid-svg-icons";

import "./collapseLayerPanel.css";

export default class CollapseLayer extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = { collapsed: false };
    this.togglePanelCollapse = this.togglePanelCollapse.bind(this);
  }

  componentDidUpdate() {
    if (this.props.fileChanged) {
      this.togglePanelExpand();
    }
  }

  togglePanelCollapse() {
    this.setState({ collapsed: !this.state.collapsed });
  }

  togglePanelExpand() {
    this.setState({ collapsed: false });
  }

  render() {
    return (
      <div className="collapseContainer">
        <div className="collapseTitleBar">
          <legend>{this.props.legend}</legend>
          <div className="collapseButton">
            <button
              onClick={this.togglePanelCollapse}
              className="iconButton light collapseButton"
              type="button"
              title={this.state.collapsed ? "Expand" : "Collapse"}
            >
              {this.state.collapsed ? (
                <FontAwesomeIcon icon={faChevronDown} size="sm" />
              ) : (
                <FontAwesomeIcon icon={faChevronUp} size="sm" />
              )}
            </button>
          </div>
        </div>
        <div className={this.state.collapsed ? "layerHidden" : "layerShown"}>
          {this.props.children}
        </div>
      </div>
    );
  }
}
